import { useState } from "react";

export const KarmaPoolUserManager = (local, setLocal, getURLBasePath) => {
    const [authToken, setAuthToken] = useState(() => {
        const authToken = sessionStorage.getItem("jwtAuthToken");
        console.log("authToken state: " + authToken);
        return authToken ? authToken : null;
    });
    
    function refresh() {
        if (authToken == null) {
            if (window.localStorage.getItem("jwtAuthToken") === null || window.localStorage.getItem("jwtAuthToken") === "") {
                console.log("no auth token");
                return;
            }

            setAuthTokenToLocalStorageJwtAuthToken();
        }

        let authTokenFinal = authToken == null ? window.localStorage.getItem("jwtAuthToken") : authToken;
        
        fetchUser(authTokenFinal);
    }

    function fetchUser(authToken)
    {
        // Path param boolean for requestAllUsers is false
        fetch(getURLBasePath() + 'user?requestAllUsers=false', {
                headers: new Headers({
                'Authorization': authToken
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log("Login data: ");
                console.log(data);

                var loginNotificationRead = false;

                if (local.user !== undefined && local.user !== null) {
                    loginNotificationRead = local.user.seenLoginNotification;
                }

                setLocal(prevValue => {
                    return { ...prevValue, user: {...data, seenLoginNotification : loginNotificationRead} };
                });

                localStorage.setItem("user", JSON.stringify(data));
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function setAuthTokenToLocalStorageJwtAuthToken() {
        setAuthToken((prevValue) => {
            return window.localStorage.getItem("jwtAuthToken");
        });
        localStorage.setItem("jwtAuthToken", window.localStorage.getItem("jwtAuthToken"));
    }

    return {
        refresh: refresh
    };
}